import { P, Tile, Col, media, Form } from 'ia-react-core';
import styled from 'styled-components';

export const StyledTile = styled(Tile)`
height: 62%;
padding-bottom: 36px;
 h4{
  margin-bottom: 16px;
 }
`;

export const StyledP = styled(P)`
  line-height: 1.29;
  margin-bottom: 16px;
`;

export const StyledForm = styled(Form)`
max-width: 100%;
`;

export const StyledSearchTileCol = styled(Col)`
${media.sm`
padding-right: 16px;
:first-child:last-child{
  ${StyledForm} {
    max-width: 50%;
  }
}
`}
 max-width: 100%;
 padding-bottom: 0px;
`;
